import React from 'react'
import useStore from '../../../../BusinessStore/Store'
import uploadIcon from '../../../../../img/uploadSVG.svg'
import styles from './styles.module.css'

function BusinessCategories () {
  const { isQueryLoading, setCountry, setRequiredFields, setRawCategory } =
    useStore()

  const onClickRestaurantsInTheUS = () => {
    if (isQueryLoading) return
    setCountry('US')
    setRequiredFields(['address'])
    setRawCategory('restaurants')
  }
  const onClickHotelsInTheUS = () => {
    if (isQueryLoading) return
    setCountry('US')
    setRequiredFields(['address'])
    setRawCategory('hotels')
  }
  const onClickBusinessCategoriesBanking = () => {
    if (isQueryLoading) return
    setCountry('US')
    setRequiredFields(['address'])
    setRawCategory('banking')
  }

  return (
    <section>
      <div className={styles.businessCategoriesContainer}>
        <h2 className={styles.businessCategoriesTitle}>
          Common business categories
        </h2>
        <div className={styles.businessCategoriesValues}>
          <div
            className={`${styles.businessCategoriesItem} ${
              isQueryLoading ? styles.businessCategoriesItemDisabled : ''
            }`}
            onClick={onClickRestaurantsInTheUS}
          >
            <div>
              <span className={styles.businessCategoriesSpan}>Restaurants</span>

              <p className={styles.businessCategoriesText}>
                Restaurants in the US
              </p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.businessCategoriesImg}
            />
          </div>
          <div
            className={`${styles.businessCategoriesItem} ${
              isQueryLoading ? styles.businessCategoriesItemDisabled : ''
            }`}
            onClick={onClickHotelsInTheUS}
          >
            <div>
              <span className={styles.businessCategoriesSpan}>Hotels</span>
              <p className={styles.businessCategoriesText}>Hotels in the US</p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.businessCategoriesImg}
            />
          </div>
          <div
            className={`${styles.businessCategoriesItem} ${
              isQueryLoading ? styles.businessCategoriesItemDisabled : ''
            }`}
            onClick={onClickBusinessCategoriesBanking}
          >
            <div>
              <span className={styles.businessCategoriesSpan}>Banking</span>
              <p className={styles.businessCategoriesText}>
                Retail bank locations in the US
              </p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.businessCategoriesImg}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default BusinessCategories
